<template>
  <div>
    <div id="Loader" v-if="LoadYn">
      <div class="spinner-bar">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <b-row class="h600 chartarea" v-if="isDynamicSensor(defaultInfo.devtype)">
      <b-col class="col-6 pr10">
        <b-card
          class="h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">{{ dataChart1.title }}abc</h6>
          <div id="dataChart1" class="graph default-border-top1"></div>
        </b-card>
      </b-col>
      <b-col class="col-6 pl10">
        <b-card
          class="h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">
            {{ dataChart2.title }}
          </h6>
          <div id="dataChart2" class="graph default-border-top1"></div>
          <ag-grid-vue
            v-show="false"
            class="ag-theme-balham realtimeGrid"
            :gridOptions="realtimeDataGridOptions"
          ></ag-grid-vue>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="h600 chartarea" v-else>
      <b-col class="col-12">
        <b-card
          class="h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">
            {{ dataChart1.title }}
          </h6>
          <div id="dataChart1" class="graph default-border-top1"></div>
        </b-card>
      </b-col>
    </b-row>
    <div class="btnGrp" style="display: flex; justify-content: space-between">
      <div class="jcfs pl20">
        <b-button class="full-chartBtn" @click="showTriggerLine()"
          ><i :class="isShowTriggerLine ? 'fas fa-eye-slash' : 'fas fa-eye'"></i
          >트리거</b-button
        >
      </div>
      <div class="jcfe pr20">
        <b-button
          v-if="defaultInfo.devtype === '10'"
          class="full-searchBtn"
          @click="saveRealtimeDataRecorded()"
        >
          <i :class="isRecording ? 'fas fa-stop' : 'fas fa-circle'"></i>
          {{ isRecording ? "기록중지" : "기록" }}
        </b-button>
        <b-button
          class="full-startBtn"
          @click="cmdRealtimeData('start')"
          :disabled="btnDisabled"
          ><i class="fas fa-play"></i>시작</b-button
        >
        <b-button
          class="full-stopBtn"
          @click="cmdRealtimeData('stop')"
          :disabled="!btnDisabled"
          ><i class="fas fa-pause"></i>중지</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import utils from "../common/utils";
import moment from "moment";
import chartUtil from "../common/chartUtil";
import { AgGridVue } from "ag-grid-vue";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AgGridVue,
  },
  computed: {
    ...mapGetters([
      "getAlertOptions",
      "getConfirmOptions",
      "getCenterBus",
      "getWebSocket",
    ]),
  },
  props: {
    defaultInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      LoadYn: false,
      btnDisabled: true,
      curTopicId: null,
      dataChart1: {
        title: "Realtime Data Plot",
        x: [],
        y: [],
      },
      dataChartCnt: 900,
      dataChart2: {
        title: "Realtime FFT Plot",
        x: [],
        y: [],
      },
      isFirst: true,
      isRecording: false,
      realtimeDataRecorded: [],
      realtimeDataGridOptions: {
        columnDefs: [
          { headerName: "날짜", field: "date" },
          { headerName: "시간", field: "time" },
          { headerName: "데이터", field: "data", contentType: "number" },
        ],
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "multiple",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
      },
      isShowTriggerLine: false,
      triggerLine: [],
      highT: null,
      lowT: null,
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.reloadEvent);
    this.cmdRealtimeData("start");

    this.getCenterBus.$on("webSocketServerMessage", (param) => {
      if (param) {
        switch (param.target) {
          case "rabbitMQData":
            let data = JSON.parse(param.data);
            this.subRealtimeData(data);
            break;
          case "rabbitMQError":
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(param.data, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
            break;
        }
      }
    });
  },
  destroyed() {
    this.cmdRealtimeData("stop");
    window.removeEventListener("beforeunload", this.reloadEvent);
    this.getCenterBus.$off("webSocketServerMessage");
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    reloadEvent() {
      this.cmdRealtimeData("stop");
    },
    cmdRealtimeData(cmd) {
      if (cmd === "start") {
        this.LoadYn = true;
        this.setRealtimeData(cmd);
      } else {
        this.LoadYn = true;
        this.unSubRealtimeData();
        if (this.curTopicId) {
          this.setRealtimeData(cmd);
        }
      }
    },
    setRealtimeData(cmd) {
      var reqBody = {
        devid: this.defaultInfo.devid,
        devtype: this.defaultInfo.devtype,
        sensoridx: this.defaultInfo.sensoridx,
        command: cmd,
        mq_topic_id: cmd === "stop" ? this.curTopicId : null,
      };

      this.$http
        .post("/sensor/cmdRealtimeData", reqBody, { timeout: 10000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.LoadYn = false;
            if (cmd === "start") {
              var chartData = res.data.data;
              if (
                Object.keys(chartData).length !== 0 &&
                chartData.mq_topic_id !== undefined
              ) {
                this.btnDisabled = true;

                if (this.isDynamicSensor(this.defaultInfo.devtype)) {
                  this.dataChart1.x = [];
                  this.dataChart1.y = [];
                  this.dataChart2.x = [];
                  this.dataChart2.y = [];
                } else {
                  this.dataChart1.x = [];
                  this.dataChart1.y = [];
                }

                this.highT = chartData.highT;
                this.lowT = chartData.lowT;

                this.curTopicId = chartData.mq_topic_id;

                if (
                  chartData.highT !== undefined &&
                  chartData.lowT !== undefined
                ) {
                  this.triggerLine = [chartData.highT, chartData.lowT];
                }

                this.getWebSocket.send(
                  JSON.stringify({
                    target: "onRabbitMQData",
                    exchange: chartData.exchange,
                    topic: this.curTopicId,
                  })
                );
              } else {
                this.setAlertTitle();
                this.$bvModal
                  .msgBoxOk(
                    "해당 데이터가 존재하지 않습니다.",
                    this.getAlertOptions
                  )
                  .then((value) => {})
                  .catch((err) => {
                    console.error(err);
                  });
              }
            } else {
              this.btnDisabled = false;
              this.curTopicId = null;
            }
          } else {
            this.LoadYn = false;
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(utils.chkNull(res.data.error_msg), this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    // x축이 시간인 라인 차트 그리기
    drawTimeLineChart(id, param, range) {
      var data = [
        {
          x: param.x,
          y: param.y,
          name: param.name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      var layout = chartUtil.setTimeLayout(id, {
        datacnt: param.x.length,
        showxaxiscnt: 4,
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 80
              : 50,
          r: 30,
          t: 20,
          b: 30,
          pad: 0,
        },
      });
      if (param.shape !== undefined && param.shape !== null) {
        layout.shapes = [];
        for (let i = 0; i < param.shape.length; i++) {
          layout.shapes.push({
            type: "line",
            xref: "paper",
            x0: 0,
            y0: param.shape[i],
            x1: 1,
            y1: param.shape[i],
            line: {
              color: "#fff",
              width: 1,
              dash: "longdash",
            },
          });
          layout.shapes[i].visible = false;
        }
      }
      if (range !== undefined && range !== null) {
        if (range.x !== undefined && range.x !== null) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (range.y !== undefined && range.y !== null) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    showTriggerLine() {
      this.isShowTriggerLine = !this.isShowTriggerLine;
      if (this.isShowTriggerLine) {
        if (this.triggerLine.length === 0) {
          this.setAlertTitle();
          this.$bvModal
            .msgBoxOk("트리거 정보가 없습니다.", this.getAlertOptions)
            .then((value) => {
              return;
            });
        }
      }
      Plotly.relayout("dataChart1", {
        "shapes[0].visible": this.isShowTriggerLine,
        "shapes[1].visible": this.isShowTriggerLine,
      });
    },
    drawLineChart(id, param, range) {
      var data = [
        {
          x: param.x,
          y: param.y,
          name: param.name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      var layout = chartUtil.setTimeLayout(id, {
        datacnt: param.x.length,
        showxaxiscnt: 6,
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 80
              : 50,
          r: 50,
          t: 20,
          b: 30,
          pad: 0,
        },
      });
      layout.xaxis.tickformat = "d";
      if (range !== undefined && range !== null) {
        if (range.x !== undefined && range.x !== null) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (range.y !== undefined && range.y !== null) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    subRealtimeData(data) {
      if (data) {
        if (this.isDynamicSensor(this.defaultInfo.devtype)) {
          if (Object.keys(data).includes("data")) {
            // 최대 수용 개수 초과하면 앞에서부터 현재 넣을 개수만큼 빼기
            // if (this.dataChart1.x.length > this.dataChartCnt) {
            //   for (let i = 0; i < msg.data.length; i++) {
            //     this.dataChart1.x.shift()
            //     this.dataChart1.y.shift()
            //   }
            // }
            // for (let i = 0; i < msg.data.length; i++) {
            //   this.dataChart1.x.push(moment(msg.data[i][0]).format('YYYY-MM-DD HH:mm:ss.SSS'))
            //   this.dataChart1.y.push(msg.data[i][1])
            // }
            let dataChart1 = { x: [], y: [] };
            for (let i = 0; i < data.data.length; i++) {
              dataChart1.x.push(
                moment(data.data[i][0]).format("YYYY-MM-DD HH:mm:ss.SSS")
              );
              dataChart1.y.push(data.data[i][1]);
            }
            if (this.isFirst) {
              this.drawTimeLineChart("dataChart1", {
                x: this.dataChart1.x,
                y: this.dataChart1.y,
                name: "data",
                shape:
                  this.highT === undefined || this.lowT === undefined
                    ? null
                    : [this.highT, this.lowT],
              });
              this.isFirst = false;
            } else {
              Plotly.extendTraces(
                "dataChart1",
                { x: [dataChart1.x], y: [dataChart1.y] },
                [0],
                this.dataChartCnt
              );
            }
          } else {
            this.dataChart2.x = data.fft.freq;
            this.dataChart2.y = data.fft.amp;
            this.drawLineChart("dataChart2", {
              x: this.dataChart2.x,
              y: this.dataChart2.y,
              name: "fft",
            });
          }
        } else {
          if (Object.keys(data).includes("data")) {
            // this.dataChart1.x.push(
            //   moment(msg[0]).format("YYYY-MM-DD HH:mm:ss.SSS")
            // );
            // this.dataChart1.y.push(msg[1]);
            // this.drawTimeLineChart("dataChart1", {
            //   x: this.dataChart1.x,
            //   y: this.dataChart1.y,
            //   name: "data",
            // });
            let dataChart1 = { x: [], y: [] };
            if (this.isFirst) {
              this.dataChart1.x.push(
                moment(data[0]).format("YYYY-MM-DD HH:mm:ss.SSS")
              );
              this.dataChart1.y.push(data[1]);
              this.drawTimeLineChart("dataChart1", {
                x: this.dataChart1.x,
                y: this.dataChart1.y,
                name: "data",
                shape:
                  this.highT === undefined || this.lowT === undefined
                    ? null
                    : [this.highT, this.lowT],
              });
              this.isFirst = false;
            } else {
              dataChart1.x.push(
                moment(data[0]).format("YYYY-MM-DD HH:mm:ss.SSS")
              );
              dataChart1.y.push(data[1]);
              Plotly.extendTraces(
                "dataChart1",
                { x: [dataChart1.x], y: [dataChart1.y] },
                [0],
                this.dataChartCnt
              );
            }
          }
        }
      }
    },
    unSubRealtimeData() {
      console.log("RealTime Data unsubscribe..");
      this.getWebSocket.send(
        JSON.stringify({
          target: "offRabbitMQData",
          topic: this.curTopicId,
        })
      );
    },
    closeModal() {
      this.cmdRealtimeData("stop");
      this.$nextTick(() => {
        this.$bvModal.hide("sensorDataChartModal");
      });
    },
    isDynamicSensor: utils.isDynamicSensor,
    isStaticSensor: utils.isStaticSensor,
    saveRealtimeDataRecorded() {
      this.isRecording = !this.isRecording;
      // console.log("isRecording is " + this.isRecording);
      if (!this.isRecording) {
        let data = [];
        for (let el of this.realtimeDataRecorded) {
          if (el === undefined) {
            continue;
          }
          for (let e of el) {
            data.push({
              date: e[0].split(" ")[0],
              time: e[0].split(" ")[1],
              data: e[1],
            });
          }
        }
        let beginTime = this.realtimeDataRecorded[0][0][0];
        beginTime = beginTime.replace(" ", "");
        beginTime = beginTime.split(".")[0];

        let lastArray =
          this.realtimeDataRecorded[this.realtimeDataRecorded.length - 1];
        let endTime = lastArray[lastArray.length - 1][0];
        endTime = endTime.replace(" ", "");
        endTime = endTime.split(".")[0];

        this.realtimeDataRecorded = [];
        this.realtimeDataGridOptions.api.setRowData(data);
        this.excelDownload(
          "실시간_차트_데이터_" +
            this.defaultInfo.deviceid +
            "_" +
            beginTime +
            "_" +
            endTime
        );
      }
    },
    excelDownload(fileName) {
      let param = {
        fileName: fileName,
        sheetName: "sheet1",
      };
      utils.excelDownload(
        param,
        this.realtimeDataGridOptions,
        "/comn/excelDownload",
        null,
        param.fileName
      );
    },
  },
};
</script>

<style lang="scss">
#sensorDataChartModal .modal-dialog {
  max-width: 1500px;
  & .chartarea {
    padding: 20px;
    & .card {
      padding: 0;
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #1f2327;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/SensorDataChartModal.vue